import { core } from '../core/index.js';
import { filterFabricErrors } from '../errors/errors.js';

/**
 * 展示人脸识别返回结果.
 */
export type FabricShowFaceIdOptions = {};

/**
 * 展示人脸识别返回结果.
 */
export type FabricShowFaceIdCallbackData = {
  /**
   * success = '0' (识别成功)
   */
  status: '0';
  /**
   * 预留消息
   */
  message: string;
  /**
   * 用于校验上传数据的校验字符串
   */
  delta: string;
  /**
   * 用于假脸判定，请传MegLive SDK返回的用作云端假脸攻击判定的照片，FaceID将使用image_env进行假脸判定，完整返回face_genuineness对象中的所有字段。
   */
  imageEnv?: string;
  /**
   * 识别的人脸图片内容, 目前返回base64
   */
  faceImgBase64: string;
};

export type FabricMarkShowFaceIdApi = (
  options: FabricShowFaceIdOptions
) => Promise<FabricShowFaceIdCallbackData>;

/**
 * 展示人脸识别SDK
 */
export const showFaceId: FabricMarkShowFaceIdApi = (
  options: FabricShowFaceIdOptions
): Promise<FabricShowFaceIdCallbackData> => {
  return new Promise<FabricShowFaceIdCallbackData>((resolve, reject) => {
    core.call<
      'fabric_mark_faceid.showFaceId',
      FabricShowFaceIdOptions,
      FabricShowFaceIdCallbackData
    >('fabric_mark_faceid.showFaceId', options, (result) => {
      const fabricErrors = filterFabricErrors(
        result.code,
        result.message,
        result.data
      );
      if (fabricErrors) {
        reject(fabricErrors);
      } else {
        resolve(result.data);
      }
    });
  });
};
